import React from "react";
import { useNavbarStyles, WhiteTooltip, RedTooltip } from "../../styles";
import {
  AppBar,
  Hidden,
  InputBase,
  Avatar,
  Fade,
  Grid,
  Typography,
  Zoom
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import logo from "../../images/logo.png";
import {
  LoadingIcon,
  AddIcon,
  LikeIcon,
  LikeActiveIcon,
  ExploreIcon,
  ExploreActiveIcon,
  HomeIcon,
  HomeActiveIcon
} from "../../icons";
import NotificationTooltip from "../notification/NotificationTooltip";
import NotificationList from "../notification/NotificationList";
import {useSelector,useDispatch} from "react-redux"

function Navbar({ minimalNavbar,data }) {
  const classes = useNavbarStyles();
  const history = useHistory();
  const [isLoadingPage, setLoadingPage] = React.useState(true);
  const path = history.location.pathname;

  React.useEffect(() => {
    setLoadingPage(false);
  }, [path]);

  return (
    <>
      <AppBar className={classes.appBar}>
        <section className={classes.section}>
          <Logo />
          {!minimalNavbar && (
            <>
              <Search history={history} data={data} />
              <Links path={path} />
            </>
          )}
        </section>
      </AppBar>
    </>
  );
}

function Logo() {
  const classes = useNavbarStyles();

    return (
      <div className={classes.logoContainer}>
      <Link to="/">
        <div className={classes.logoWrapper}>
          <img src={logo} alt="Twitter" className={classes.logo} />
        </div>
      </Link>
    </div>
  );
}

function Search({ history , data}) {
  const classes = useNavbarStyles();
  const [loading] = React.useState(false);
  const [results, setResults] = React.useState([]);
  const [query, setQuery] = React.useState("");

  const hasResults = Boolean(query) && results.length > 0;

  // React.useEffect(() => {
  //   if (!query.trim()) return;
  //   setResults(Array.from({ length: 5 }, () => getDefaultUser()));
  // }, [query]);

  function handleClearInput() {
    setQuery("");
  }

  return (
      <h1 style={{"font-family": `'Playfair Display', serif`,fontSize:"2em",color:'whitesmoke'}}>{data}</h1>
      // <WhiteTooltip
      //   arrow
      //   interactive
      //   TransitionComponent={Fade}
      //   open={hasResults}
      //   title={
      //     hasResults && (
      //       <Grid className={classes.resultContainer} container>
      //         {results.map(result => (
      //           <Grid
      //             key={result.id}
      //             item
      //             className={classes.resultLink}
      //             onClick={() => {
      //               history.push(`/${result.username}`);
      //               handleClearInput();
      //             }}
      //           >
      //             <div className={classes.resultWrapper}>
      //               <div className={classes.avatarWrapper}>
      //                 <Avatar src={result.profile_image} alt="user avatar" />
      //               </div>
      //               <div className={classes.nameWrapper}>
      //                 <Typography variant="body1">{result.username}</Typography>
      //                 <Typography variant="body2" color="textSecondary">
      //                   {result.name}
      //                 </Typography>
      //               </div>
      //             </div>
      //           </Grid>
      //         ))}
      //       </Grid>
      //     )
      //   }
      // >
      //   <InputBase
      //     className={classes.input}
      //     onChange={event => setQuery(event.target.value)}
      //     startAdornment={<span className={classes.searchIcon} />}
      //     endAdornment={
      //       loading ? (
      //         <LoadingIcon />
      //       ) : (
      //         <span onClick={handleClearInput} className={classes.clearIcon} />
      //       )
      //     }
      //     placeholder="Search"
      //     value={query}
      //   />
      // </WhiteTooltip>
  );
}


function Links({ path }) {
  const myState=useSelector((state)=>state.changeToken)
  const myState1=useSelector((state)=>state.changeToken1)
  const user_data=useSelector((state)=>state.changeUserData)
  const classes = useNavbarStyles();

  return (
    <div className={classes.linksContainer}>
      <div className={classes.linksWrapper}>
        <Hidden xsDown>
          <AddIcon />
        </Hidden>
        <Link to="/">{path === "/" ? <HomeActiveIcon /> : <HomeIcon />}</Link>
        {myState && myState1 && <Link to="/profile">
          <div
            className={classes.profileActive}
          ></div>
          <Avatar
            src={user_data.imgurl}
            className={classes.profileImage}
          />
        </Link>}
      </div>
    </div>
  );
}

export default Navbar;
